import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsColumnsInfo'

export default function ConvenienceDoorExportModal(props: ExportModalProps) {
  const dataTypeName = 'Convenience Store Doors'

  const convenienceColumnHelper = createExportColumnHelper({
    columns: CONVENIENCE_DOORS_COLUMNS,
  })

  const columns = [
    {
      title: 'Opportunity Attributes',
      elements: [
        convenienceColumnHelper.retrieveColumn('name'),
        convenienceColumnHelper.retrieveColumn('chain_id'),
        convenienceColumnHelper.retrieveColumn('address'),
        convenienceColumnHelper.retrieveColumn('city'),
        convenienceColumnHelper.retrieveColumn('state'),
        convenienceColumnHelper.retrieveColumn('country'),
        convenienceColumnHelper.retrieveColumn('phone'),
        convenienceColumnHelper.retrieveColumn('website'),
        convenienceColumnHelper.retrieveColumn('reviews_avg'),
        convenienceColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceColumnHelper.retrieveColumn('open_hours'),
        convenienceColumnHelper.retrieveColumn('chain_doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  return (
    <ExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      {...props}
    />
  )
}
